import React from 'react';
import emailjs, { init } from 'emailjs-com'
init("user_XBzycAU6dr7IM5Ffftqlb");
export default function Contact(props) {
  function sendEmail(e) {
    e.preventDefault();
    console.log(e.target)
    emailjs.sendForm('service_eklavya', 'template_svltsc3', e.target)
      .then((result) => {
          alert(result, "Your message is sent successfully!");
      }, (error) => {
          alert("Error: " + error.text + "\nPlease try again later");
      });
  }
  return (
      <>
      <form onSubmit={sendEmail} >
      <div className = "container text-start">
      <br/>
      <h1>Contact Me:</h1>
      <br/>
      <div className="form-floating mb-3">
        <input type="text" name = "from_name" className="form-control" id="floatingName" placeholder="Name"/>
        <label htmlFor="floatingName">Name</label>
      </div>
      <div className="form-floating mb-3">
      <input name = "from_email" type="emailid" className="form-control" id="floatingEmail" placeholder="For replying"/>
      <label htmlFor="floatingInput">Email address</label>
      </div>
      <div className="form-floating">
      <textarea name="message" type="text" className="form-control" id = "floatingMsg" style={{height: '30vh'}} placeholder="Your Message Here"/>
      <label htmlFor="floatingText">Message</label>
      </div>
      <br/>
      <button type="submit" className="sbtn key-btn green-btn">
      Send
      </button>
      </div>
      </form>
      </>
)}